'use client'

import WorkflowNavigation from './template/workflowNavigation'

export default function Template({ children }: { children: React.ReactNode }) {
  return <WorkflowNavigation>{children}</WorkflowNavigation>
}
